<template>
  <div>
    <div class="">
      <myswiper :swipers="swipers"></myswiper>
    </div>

    <grid></grid>

    <el-container>
      <paymentlist></paymentlist>

      <el-main>
        <notice></notice>
      </el-main>

      <el-footer>
        Developed by 龍科技
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  import myswiper from '@/components/swiper.vue';
  import paymentlist from '@/components/paymentlist.vue';
  import grid from '@/components/grid.vue';
  import notice from '@/components/notice.vue';

  export default {
    name: 'lifepay',
    // 组件注册
    components: {

      paymentlist,
      myswiper,
      grid,
      notice
    },
    data() {
      return {
        swipers: [],
      }
    },
    methods: {
    },
    mounted() {
      let auth_token = localStorage.getItem('auth_token');
      if (!auth_token) {
        this.$message({
          message: "请先登录！",
          type: "warning",
        })
        setTimeout(() => {
          this.$router.push('/');
        }, 2000);
      }

      if (sessionStorage.getItem("banners")) {
        this.swipers = sessionStorage.getItem("banners");
      }
    }
  }
</script>
<style scoped>
  .el-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
  }
</style>



// WEBPACK FOOTER //
// src/page/lifepay.vue